import { render, staticRenderFns } from "./ImageDialog.vue?vue&type=template&id=58fc48aa&"
import script from "./ImageDialog.vue?vue&type=script&lang=js&"
export * from "./ImageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports